import type { SectionMark } from './types';

/**
 * The numbered circle (crossmarc/steward-app#1886), with the section's number inside it. The
 * rail no longer draws it (crossmarc/steward-app#2159: plain names and a check, see
 * `SectionRail`); the onboarding form's Review page is its one caller, beside each section's
 * heading.
 *
 *  - not started: a hollow circle in the hairline colour, numeral in `mid`;
 *  - started: a bronze ring, numeral in `navy`;
 *  - done: a filled bronze circle with an ink numeral. Fill is `bronze` itself (#A1855F light,
 *    #D9A066 dark) and the numeral is `ink`, a constant dark, so the pair is dark-on-bronze in
 *    both themes. `navy` would flip to a light tone in dark mode and lose the contrast.
 */
export function SectionIndicator({ mark, number }: { mark: SectionMark; number?: number }) {
  const base = 'inline-flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full text-[11px] font-semibold leading-none tabular-nums';
  const tone =
    mark === 'done' ? 'border border-bronze bg-bronze text-ink'
    : mark === 'started' ? 'border-2 border-bronze text-navy'
    : 'border border-line-strong text-mid';
  return (
    <span aria-hidden="true" data-mark={mark} className={`${base} ${tone}`}>
      {number}
    </span>
  );
}
